module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-254.3cc42d7.woff2";